import { copyShareableUrl, formatCurrency, formatPercent, getQueryParams, updateQueryParams } from '../shared/calculator';
import { isTaxError } from '../shared/types';
import { calculateCanadianTax } from './tax';

const provinceSelect = document.getElementById('province') as HTMLSelectElement;
const taxYearSelect = document.getElementById('tax-year') as HTMLSelectElement;
const incomeInput = document.getElementById('income') as HTMLInputElement;
const otherIncomeInput = document.getElementById('other-income') as HTMLInputElement;
const rrspInput = document.getElementById('rrsp') as HTMLInputElement;
const capitalGainsInput = document.getElementById('capital-gains') as HTMLInputElement;
const errorEl = document.getElementById('error') as HTMLDivElement;

const params = getQueryParams({
  province: 'ON',
  income: '100000',
  otherIncome: '0',
  rrsp: '0',
  capitalGains: '0',
  taxYear: '2026',
});
provinceSelect.value = params.province;
incomeInput.value = params.income;
otherIncomeInput.value = params.otherIncome;
rrspInput.value = params.rrsp;
capitalGainsInput.value = params.capitalGains;
taxYearSelect.value = params.taxYear;

function render(): void {
  const result = calculateCanadianTax({
    province: provinceSelect.value,
    employmentIncome: Number(incomeInput.value),
    otherIncome: Number(otherIncomeInput.value),
    rrspDeductions: Number(rrspInput.value),
    capitalGains: Number(capitalGainsInput.value),
    taxYear: Number(taxYearSelect.value),
  });

  updateQueryParams({
    province: provinceSelect.value,
    income: incomeInput.value,
    otherIncome: otherIncomeInput.value,
    rrsp: rrspInput.value,
    capitalGains: capitalGainsInput.value,
    taxYear: taxYearSelect.value,
  });

  if (isTaxError(result)) {
    errorEl.textContent = result.error;
    errorEl.style.display = 'block';
    return;
  }

  errorEl.style.display = 'none';
  (document.getElementById('federal-tax') as HTMLParagraphElement).textContent =
    formatCurrency(result.federalTax);
  (document.getElementById('provincial-tax') as HTMLParagraphElement).textContent =
    formatCurrency(result.provincialTax);
  (document.getElementById('total-tax') as HTMLParagraphElement).textContent =
    formatCurrency(result.totalTax);
  (document.getElementById('after-tax') as HTMLParagraphElement).textContent =
    formatCurrency(result.afterTaxIncome);
  (document.getElementById('marginal-rate') as HTMLParagraphElement).textContent =
    formatPercent(result.marginalRate);
  (document.getElementById('average-rate') as HTMLParagraphElement).textContent =
    formatPercent(result.averageRate);
}

[provinceSelect, taxYearSelect, incomeInput, otherIncomeInput, rrspInput, capitalGainsInput].forEach(
  (el) => {
    el.addEventListener('input', render);
    el.addEventListener('change', render);
  },
);

document.getElementById('share-btn')?.addEventListener('click', () => {
  copyShareableUrl({
    province: provinceSelect.value,
    income: incomeInput.value,
    otherIncome: otherIncomeInput.value,
    rrsp: rrspInput.value,
    capitalGains: capitalGainsInput.value,
    taxYear: taxYearSelect.value,
  }).then(() => {
    const btn = document.getElementById('share-btn') as HTMLButtonElement;
    btn.textContent = '✅ Copied!';
    setTimeout(() => {
      btn.textContent = '📋 Copy shareable link';
    }, 2000);
  });
});

render();
